export default __webpack_public_path__ + "fd12bde9dc50409da244eb7ba80f6548.png";